import { memo, ReactNode, useContext } from "react";
import { UserSettingContext } from "@tecorien/mimic";
import { AvailableFontsArray } from "components/Signature/fonts";
import { Permissions } from "permissions";
import { useKeycloak } from "../../keycloak";
import { UserProfileForm } from "./UserProfileForm";

export type UserProfileCheckerProps = {
  children: ReactNode | ReactNode[]
}

export const UserProfileChecker = memo<UserProfileCheckerProps>(({ children }) => {
  const { tokenData, roles } = useKeycloak();
  const { initialized, settings } = useContext(UserSettingContext);

  const shouldCheckProfile = roles.some(x => x === Permissions.AffiliateManager);

  if (shouldCheckProfile) {
    if (!initialized || !tokenData) {
      return null;
    }


    const signature = (!!settings.signature && !!AvailableFontsArray.find(x => x === settings.signature?.font))
      ? settings.signature
      : null;

    if ((!tokenData.firstName || !tokenData.lastName || !signature)) {
      return <UserProfileForm me={{
        firstName: tokenData.firstName,
        lastName: tokenData.lastName,
        signature,
      }} />;
    }
  }

  return (
    <>
      {children}
    </>
  );
});

export default UserProfileChecker;